import generateNumberArrayByRange from '../number/generateNumberArrayByRange'

/**
 * @namespace
 * @property {object}  carFormFields
 * @property {number}  carFormFields.title
 * @property {string}  carFormFields.sellerName
 * @property {string}  carFormFields.sellerPhone
 * @property {boolean}  carFormFields.saleElsewhere
 * @property {boolean}  carFormFields.reserve
 * @property {string}  carFormFields.subtitle
 * @property {string}  carFormFields.endDate
 * @property {string}  carFormFields.historyReport
 * @property {string}  carFormFields.year
 * @property {string}  carFormFields.make
 * @property {string}  carFormFields.model
 * @property {string}  carFormFields.location
 * @property {string}  carFormFields.country
 * @property {string}  carFormFields.zipCode
 * @property {string}  carFormFields.cityAndProvince
 * @property {string}  carFormFields.vin
 * @property {string}  carFormFields.mileage
 * @property {string}  carFormFields.bodyStyle
 * @property {string}  carFormFields.engine
 * @property {string}  carFormFields.drivetrain
 * @property {string}  carFormFields.transmission
 * @property {string}  carFormFields.exteriorColor
 * @property {string}  carFormFields.interiorColor
 * @property {('clean' | 'salvage' | 'rebuilt' | 'not actual mileage')}  carFormFields.titleStatus
 * @property {('Dealer' | 'Private party')}  carFormFields.sellerType
 * @property {string}  carFormFields.highlights
 * @property {string}  carFormFields.equipment
 * @property {string}  carFormFields.modifications
 * @property {string}  carFormFields.knownFlaws
 * @property {string}  carFormFields.recentServiceHistory
 * @property {string}  carFormFields.otherItemsIncludedInSale
 * @property {string}  carFormFields.dealershipName
 * @property {string}  carFormFields.dealershipWebsite
 * @property {string}  carFormFields.sellersOwnershipHistory
 * @property {string}  carFormFields.sellerNotes
 * @property {string[]}  carFormFields.videos
 * @property {(FileList | File[])}  carFormFields.carImagesExterior
 * @property {FileList | File[]}  carFormFields.carImagesInterior
 * @property {(FileList | File[])}  carFormFields.carImagesMechanical
 * @property {(FileList | File[])}  carFormFields.carImagesDocs
 * @property {(FileList | File[])}  carFormFields.carImagesOther
 */
 const carFormFields = {
  title: 'title',
  sellerName: 'sellerName',
  sellerPhone: 'sellerPhone',
  saleElsewhere: 'saleElsewhere',
  reserve: 'reserve',
  reserveValue: 'reserveValue',
  soldAfterAuctionValue: 'soldAfterAuctionValue',
  subtitle: 'subtitle',
  endDate: 'endDate',
  historyReport: 'historyReport',
  year: 'year',
  make: 'make',
  model: 'model',
  location: 'location',
  country: 'country',
  zipCode: 'zipCode',
  cityAndProvince: 'cityAndProvince',
  vin: 'vin',
  mileage: 'mileage',
  bodyStyle: 'bodyStyle',
  engine: 'engine',
  drivetrain: 'drivetrain',
  transmission: 'transmission',
  exteriorColor: 'exteriorColor',
  interiorColor: 'interiorColor',
  modelSpecificTrim: 'modelSpecificTrim',
  battery: 'battery',
  isSoldAfterAuction: 'isSoldAfterAuction',
  price: 'price',
  // autopilotSoftware: 'autopilotSoftware',
  // autopilotHardware: 'autopilotHardware',
  /**
   * @property {('clean' | 'salvage' | 'rebuilt' | 'not actual mileage')}  carFormFields.titleStatus
   */
  titleStatus: 'titleStatus',
  additionalFees: 'additionalFees',
  sellerType: 'sellerType',
  highlights: 'highlights',
  equipment: 'equipment',
  modifications: 'modifications',
  knownFlaws: 'knownFlaws',
  recentServiceHistory: 'recentServiceHistory',
  otherItemsIncludedInSale: 'otherItemsIncludedInSale',
  dealershipName: 'dealershipName',
  dealershipWebsite: 'dealershipWebsite',
  sellersOwnershipHistory: 'sellersOwnershipHistory',
  sellerNotes: 'sellerNotes',
  vehicleStock: 'vehicleStock',
  titleCountry: 'titleCountry',
  titleState: 'titleState',
  titleProvince: 'titleProvince',
  ownerHasTitle: 'ownerHasTitle',
  titleOwner: 'titleOwner',
  lienholder: 'lienholder',
  videos: 'videos',
  carImagesExterior: 'carImagesExterior',
  carImagesInterior: 'carImagesInterior',
  carImagesMechanical: 'carImagesMechanical',
  carImagesDocs: 'carImagesDocs',

  /**
   * @property {(FileList|File[])}  carFormFields.carImagesOther
   */
  carImagesOther: 'carImagesOther',
  isPayOff: "isPayOff",
  payOffAmount: "payOffAmount",
  payOffBank: "payOffBank",
}

const carFormFieldValues = {
  sellerType_Dealer: 'Dealer',
  sellerType_PrivateParty: 'Private party',
  location_US: 'US',
  location_CA: 'CA',
  titled_US: 'US',
  titled_CA: 'CA',
}

const yearOptions = generateNumberArrayByRange(1981, new Date().getFullYear())
const bodyStyleOptions = ['SUV', 'Cross Over', 'Pick Up Truck', 'Sedan', 'Coupe', 'Convertible']
const engineOptions = ['4cyl', '5cyl', '6cyl', '8cyl', '10cyl', '12cyl']
const transmissionOptions = ['Auto', 'Manual', 'Sequential']
const drivetrainOptions = ['RWD', '4WD/AWD', 'FWD']
const stateOptions = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District Of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming']
const titleStatusOptions = ['Clean', 'Salvage', 'Rebuilt', 'Not actual mileage']

const carSchedulingFormFields = {
  'asPossible': 'asPossible',
  '2weeks': '2weeks',
  '3weeks': '3weeks',
  'noPreference': 'noPreference',
}

const MAX_PHOTO_COUNT = 30
const MIN_PHOTO_COUNT = 4
const VERIFICATION_STATE = {
  APPLICATION: 1,
  SCHEDULING: 2,
  PAYMENT: 3,
  DONE: 4,
  DENY: 5,
}
const VARIFICATION_ROAD = [
  VERIFICATION_STATE.APPLICATION,
  VERIFICATION_STATE.SCHEDULING,
  VERIFICATION_STATE.PAYMENT,
  VERIFICATION_STATE.DONE,
]

const RESERVE_CAR_FEE_LISTING = 90
const NO_RESERVE_CAR_FEE_LISTING = 50

export {
  transmissionOptions,
  drivetrainOptions,
  yearOptions,
  bodyStyleOptions,
  engineOptions,
  stateOptions,
  titleStatusOptions,
  carFormFields,
  carFormFieldValues,
  carSchedulingFormFields,
  MAX_PHOTO_COUNT,
  MIN_PHOTO_COUNT,
  VERIFICATION_STATE,
  VARIFICATION_ROAD,
  RESERVE_CAR_FEE_LISTING,
  NO_RESERVE_CAR_FEE_LISTING
}
